<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    :element-loading-text="$t('Please wait')"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cRetailOrderList' }">{{
          $t("Retail business management center")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="{ path: '/comSalesIndex/cRetailOrderDetail' }"
          >{{ $t("Order details") }}</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/comSalesIndex/cPaymentPayList' }">{{
          $t("Payment record")
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t("Add payment record") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="pay_tool_block">
            <p><span class="mark">*</span>{{ $t("Payment method") }}</p>
            <!-- 支付工具 -->
            <div class="pay_tool_wrap">
              <div class="pay_tool_tit">可以选择以下工具完成订单支付：</div>
              <div class="radio_box">
                <el-radio-group
                  direction="horizontal"
                  v-model="formData.paytype"
                  @input="handleinputPaytype"
                >
                  <el-radio label="银行转账">{{
                    $t("Bank transfer")
                  }}</el-radio>
                  <el-radio label="第三方支付工具">第三方支付工具</el-radio>
                </el-radio-group>
              </div>
              <div
                class="pay_tool_list flex-rowl"
                v-if="paytoolList.length > 0"
              >
                <div
                  class="pay_tool_item"
                  v-for="(item, index) in paytoolList"
                  :key="index"
                >
                  <div class="tit">{{ item.settypeidstr }}</div>
                  <div class="main_wrap flex-rowl">
                    <div class="icon" v-if="item.settoolicon">
                      <el-image
                        style="width: 100px; height: 100px"
                        :src="item.settoolicon"
                        fit="cover"
                      ></el-image>
                    </div>
                    <!-- settypeid 1=银行结算，2=数字支付工具结算 -->
                    <div class="content" v-if="item.settypeid == 1">
                      <p class="flex-rowl">
                        账户名：{{ item.accountname }}
                        <span
                          class="copy_box"
                          :data-clipboard-text="item.accountname"
                          @click="handleCopyBtn"
                          ><i class="iconfont icon-fuzhi"></i
                        ></span>
                      </p>
                      <p class="b">开户行：{{ item.bankname }}</p>
                      <p class="flex-rowl">
                        账号：{{ item.account
                        }}<span
                          class="copy_box"
                          :data-clipboard-text="item.account"
                          @click="handleCopyBtn"
                          ><i class="iconfont icon-fuzhi"></i
                        ></span>
                      </p>
                    </div>
                    <div class="content" v-if="item.settypeid == 2">
                      <p class="b">结算工具名称：{{ item.settoolidstr }}</p>
                      <p class="flex-rowl">
                        账号：{{ item.cusacc }}
                        <span
                          class="copy_box"
                          :data-clipboard-text="item.cusacc"
                          @click="handleCopyBtn"
                          ><i class="iconfont icon-fuzhi"></i
                        ></span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 暂无数据 -->
              <div
                class="no_data"
                v-if="loadingPaytool && paytoolList.length > 0"
              >
                <p>暂无支付工具</p>
              </div>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>{{ $t("Currency") }}</p>
            <div class="radio_box">
              <el-radio-group
                direction="horizontal"
                v-model="formData.currency"
              >
                <el-radio :label="USERINFO.countryExrateObj.id"
                  >{{ USERINFO.countryExrateObj.ename }}（{{
                    USERINFO.countryExrateObj.moneyslog
                  }}）</el-radio
                >
              </el-radio-group>
            </div>
          </div>
          <div class="block">
            <p>
              <span class="mark">*</span>{{ $t("Payment amount") }}
              <span class="mark"
                >{{ COUNTRY.ename }}（{{
                  USERINFO.countryExrateObj.moneyslog
                }}）</span
              >
            </p>
            <div class="input_box">
              <el-input
                v-model="formData.paynum"
                placeholder=""
                @blur="handleBlur"
                @input="handleInput"
              />
            </div>
            <p>
              <span class="mark">*</span>{{ $t("Amount to be settled") }}：
              <span class="mark"
                >（{{ USERINFO.countryExrateObj.moneyslog }}）{{
                  tempTotalremain | formatPrice
                }}</span
              >
            </p>
          </div>
          <div class="block">
            <p><span class="mark">*</span>{{ $t("Payer account name") }}</p>
            <div class="input_box">
              <el-input v-model="formData.headname" placeholder="" />
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>{{ $t("Payer bank") }}</p>
            <div class="input_box">
              <el-input v-model="formData.bankname" placeholder="" />
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>{{ $t("Payer account number") }}</p>
            <div class="input_box">
              <el-input v-model="formData.bankaccount" placeholder="" />
            </div>
          </div>
          <div class="block">
            <p>
              <span class="mark">*</span>{{ $t("Payment voucher screenshot") }}
            </p>
            <p class="red">
              （{{
                $t("Please select image files that are no larger than 2M")
              }}）
            </p>
            <div class="upload_list flex-rowl">
              <div
                class="upload_box"
                v-for="(item, index) in picsList"
                :key="index"
                @mouseenter="enter(index)"
                @mouseleave="creenIndex = ''"
              >
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                >
                  <div v-if="item">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="item"
                      fit="cover"
                    ></el-image>
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex === index"
                    >
                      <span @click.stop="handlePictureCardPreview(item)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="handleRemove(index)"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>

                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
              <div class="upload_box custom_upload" v-if="picsList.length < 10">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  @change="handleFileChange"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">{{ $t("Confirm") }}</div>
      <div class="return_txt" @click="handleReturn">←{{ $t("Return") }}</div>
    </div>
    <!--  主要内容 end -->

    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { encryptstringview, uploadImage } from "../../../api/api";
import {
  getOrderPayDetail,
  addOrderPayLog,
  editOrderPayLog,
  getOrderListDetail,
} from "../../../api/shop";
import {
  getQySettlementInfoList,
  getAreaSettlementInfo,
  getQyBaseInfo,
} from "../../../api/company";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
import Clipboard from "clipboard";
export default {
  name: "cPaymentPayDetail",
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
      creenIndex: "",

      loading: false,
      dataItem: "", // 订单详情
      formData: {
        id: "",
        orderno: "",
        paytype: "银行转账",
        headname: "",
        bankname: "",
        bankaccount: "",
        paynum: "",
        shotcut: "",
        paytotal: "", // 订单总价
        createuser: "", //付款记录创建人
        currency: "", //
      },
      picsList: [],
      totalpaynum: "", //已付金额
      totalremain: "", // 待结清金额
      tempTotalremain: "", // 临时待结清金额

      // 结算工具
      paytoolList: [],
      loadingPaytool: false,
    };
  },
  computed: {
    ...mapState(["OPENID", "COUNTRY", "USERINFO"]),
  },
  filters: {
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) return "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    this.formData.createuser = USERINFO.truename;
    this.formData.currency = USERINFO.countryExrateObj.id;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { orderId, orderOpenid, id } = JSON.parse(res.jsondata);
        this.formData.id = id;

        this.getOrderListDetail(orderId, orderOpenid, id);
      } else {
        this.$router.back();
      }
    },

    // 触发付款方式
    handleinputPaytype() {
      this.paytoolList = [];
      this.getQyBaseInfo(this.dataItem.qyid);
    },

    // 企业结算信息管理
    getQySettlementInfoList(qyid) {
      let params = {
        pageindex: 1,
        pagesize: 15,
        qyid,
        settypeid: this.formData.paytype == "银行转账" ? 1 : 2,
        accountstate: true, // 状态 "true","启用"|"false","停用"|
        setcountryids: this.USERINFO.countryid,
      };
      getQySettlementInfoList(params).then((res) => {
        this.paytoolList = res.list;
        this.loadingPaytool = false;
      });
    },

    // 地区结算信息管理
    getAreaSettlementInfo() {
      let params = {
        pageindex: 1,
        pagesize: 15,
        countryid: this.USERINFO.countryid,
        accountstate: 1,
        settypeid: this.formData.paytype == "银行转账" ? 1 : 2,
        settoolid: "",
      };
      getAreaSettlementInfo(params).then((res) => {
        this.paytoolList = res.list;
        this.loadingPaytool = false;
      });
    },

    // 获取企业基本信息
    getQyBaseInfo(qyid) {
      this.loadingPaytool = true;
      getQyBaseInfo({ qyid }).then((res) => {
        /**
         * 是否允许独立结算isdu 是  否
         * 1、如果允许独立结算，则获取企业结算信息
         * 2、如果不允许独立结算，则获取地区结算信息
         */
        if (res.isdu == "是") {
          this.getQySettlementInfoList(qyid);
        } else {
          this.getAreaSettlementInfo();
        }
      });
    },

    // 订单详情
    getOrderListDetail(orderid, openid, id) {
      let params = {
        openid,
        orderid,
      };
      this.loading = true;
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        this.dataItem = newObj;
        this.formData.orderno = newObj.orderno;
        // this.formData.paytotal = calculator(newObj.price)
        //   .multiply(COUNTRY.rate ? COUNTRY.rate : 0)
        //   .toNumber(); // // 订单总额是换算后的
        // this.formData.paytotal = newObj.totalremain_trans + newObj.totalpaynum_trans;
        this.formData.paytotal = calculator(newObj.totalremain_trans).add(newObj.totalpaynum_trans).toNumber();
        this.totalpaynum = newObj.totalpaynum_trans; // 已付金额
        this.totalremain = newObj.totalremain_trans; // 待结清金额
        this.tempTotalremain = newObj.totalremain_trans; // 待结清金额
        this.loading = false;
        if (id) {
          this.getOrderPayDetail(id);
        }
        this.getQyBaseInfo(newObj.qyid);
      });
    },
    // 支付详情
    getOrderPayDetail(id) {
      this.loading = true;
      getOrderPayDetail({ id }).then((res) => {
        // this.dataItem = res;
        // this.formData.paytype = res.paytype;
        this.formData.headname = res.headname;
        this.formData.bankname = res.bankname;
        this.formData.bankaccount = res.bankaccount;
        this.formData.paynum = res.paynum;
        this.formData.shotcut = res.shotcut;
        this.picsList = res.shotcut.split(",");
        this.loading = false;
      });
    },

    // 输入框失去焦点
    handleBlur() {
      // 待结清金额
      let { totalremain, formData } = this;
      if (formData.paynum > totalremain) {
        this.$message(
          this.$t(
            "The entered amount cannot be greater than the amount to be settled"
          )
        );
        this.formData.paynum = "";
        this.tempTotalremain = totalremain;
        return;
      }
    },
    //
    handleInput(e) {
      let { totalremain } = this;
      if (totalremain < e) {
        return;
      }
      this.debouncedChange(totalremain, e);
    },
    // 防抖函数
    debouncedChange(newPrice, value) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.tempTotalremain = calculator(newPrice)
          .subtract(Number(value))
          .toNumber();
      }, 500); // 设置延迟时间，单位为毫秒
    },
    /**
     * 多张图片上传处理 start
     */
    // 大图预览
    handlePictureCardPreview(item) {
      this.dialogImageUrl = item;
      this.dialogVisible = true;
    },
    // 移除图片
    handleRemove(index) {
      let { picsList } = this;
      picsList.splice(index, 1);
    },
    // 移入图片区域
    enter(type) {
      this.creenIndex = type;
    },
    handleFileChange(event) {
      this.uploadImgIndex = 0;
      const files = event.target.files;

      // 递归调用上传图片方法
      this.uploadImages(files, 0);
    },
    uploadImages(files) {
      if (this.uploadImgIndex < files.length) {
        const file = files[this.uploadImgIndex];

        if (file && file.size <= 2 * 1024 * 1024) {
          // 限制文件大小为2M内
          const formData = new FormData();
          formData.append("image", file, file.name);

          uploadImage(formData).then((res) => {
            if (this.picsList.length < 6) {
              // 限制最多只能上传十张图片
              this.insertImageInfo(res.url, this.uploadImgIndex);

              // 递归调用上传下一张图片
              this.uploadImgIndex += 1;
              this.uploadImages(files);
            } else {
              this.$message(this.$t("You can only upload up to 6 pictures"));
            }
          });
        } else {
          this.$message(
            this.$t("Please select image files that are no larger than 2M")
          );
        }
      }
    },
    insertImageInfo(imageInfo, index) {
      this.$set(this.picsList, this.picsList.length, imageInfo); // 根据索引插入图片信息
      console.log(this.picsList, index, "====");
    },
    /**
     * 多张图片上传处理 end
     */

    // 保存
    query() {
      let { formData, picsList } = this;
      if (formData.paynum == "") {
        this.$message.warning(this.$t("Please enter the payment amount"));
        return;
      }
      if (formData.headname == "") {
        this.$message.warning(this.$t("Please enter the payer's account name"));
        return;
      }
      if (formData.bankname == "") {
        this.$message.warning(this.$t("Please enter the payer's bank"));
        return;
      }
      if (formData.bankaccount == "") {
        this.$message.warning(
          this.$t("Please enter the payer's account number")
        );
        return;
      }
      if (picsList.length == 0) {
        this.$message.warning(
          this.$t("Please upload a screenshot of the payment voucher")
        );
        return;
      } else {
        this.formData.shotcut = picsList.join(",");
      }
      // 计算剩余余额 商品总额减去

      this.loading = true;
      if (formData.id) {
        this.editOrderPayLog();
      } else {
        this.addOrderPayLog();
      }
    },
    // 添加数据
    addOrderPayLog() {
      addOrderPayLog(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(this.$t("Server Error"));
        }
      });
    },

    // 修改数据
    editOrderPayLog() {
      editOrderPayLog(this.formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(this.$t("Server Error"));
        }
      });
    },

    // 返回
    handleReturn() {
      this.$router.back();
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success(this.$t("Copy successful"));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("SAO chép không thành công");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    height: 65vh;
    .content_wrap {
      width: 100%;
      .form_wrap {
        // margin-right: 100px;
        width: 100%;
        .upload_list {
          flex-wrap: wrap;
          .upload_box {
            margin-right: 20px;
            margin-bottom: 20px;
            &:last-child {
              margin-right: 0;
            }
          }
          .custom_upload {
            background-color: #fbfdff;
            border: 1px dashed #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            width: 148px;
            height: 148px;
            cursor: pointer;
            line-height: 146px;
            vertical-align: top;
            cursor: pointer;
            input {
              opacity: 0;
              width: 100%;
              height: 100%;
              position: relative;
              z-index: 10;
              cursor: pointer;
            }
            .avatar-uploader-icon {
              font-size: 28px;
              color: #8c939d;
              z-index: 9;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
        .pay_tool_block {
          p {
            font-size: 16px;
            // color: #6e6e6e;
            margin-bottom: 10px;
            span {
              color: #ff0012;
              font-size: 14px;
              margin-right: 4px;
            }
          }
          .pay_tool_wrap {
            margin: 10px 0 0;
            .pay_tool_tit {
              font-size: 18px;
              color: #333333;
              margin-bottom: 16px;
            }
            .radio_box {
              margin-bottom: 20px;
            }
            .pay_tool_list {
              flex-wrap: wrap;
              .pay_tool_item {
                padding: 15px 25px;
                box-sizing: border-box;
                border: 2px dashed #1d2088;
                border-radius: 30px;
                cursor: pointer;
                margin-right: 20px;
                margin-bottom: 15px;
                &:last-child {
                  margin-right: 0;
                }
                .tit {
                  font-size: 18px;
                  color: #292929;
                  font-weight: bold;
                  margin-bottom: 5px;
                }
                .main_wrap {
                  .icon {
                    width: 100px;
                    height: 100px;
                    border-radius: 15px;
                    overflow: hidden;
                    margin-right: 12px;
                    img {
                      width: 100%;
                      height: 100%;
                    }
                  }
                  .content {
                    font-size: 16px;
                    color: #000000;
                    p {
                      margin-bottom: 8px;
                      &.b {
                        font-weight: bold;
                      }
                      &:last-child {
                        margin-bottom: 0;
                      }
                      .copy_box {
                        margin-left: 10px;
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .block {
          width: 50%;
        }
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>